import gql from 'graphql-tag';

const getAssets = gql`
  query GetAssets($organisationId: String, $offset: Int, $limit: Int) {
    getAssets(organisationId: $organisationId, offset: $offset, limit: $limit) {
      assetId
      organisationId
      filename
      title
      description
      altText
      metaData
      createdAt
      updatedAt
      permissions
      createdByUser {
        firstName,
        lastName
      }
      updatedByUser {
        firstName,
        lastName
      }
      assetFiles {
        ORIGINAL {
          assetFileId
          type
          status
          sourceUrl
        }
        THUMBNAIL {
          assetFileId
          type
          status
          sourceUrl
        }
      }
      assetRelations {
        assetRelationId
      }
    }
  }
`;

export default ((organisationId) => ({
  query: getAssets,
  module: 'assets',
  ignoreCache: true,
  buildVariables: ({ offset, limit }) => ({
    organisationId, limit, offset
  })
}));